"use strict";

var _classCallCheck = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _inherits = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _createSuper = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createSuper");

function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return generator._invoke = function (innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; }(innerFn, self, context), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == typeof value && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; this._invoke = function (method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); }; } function maybeInvokeDelegate(delegate, context) { var method = delegate.iterator[context.method]; if (undefined === method) { if (context.delegate = null, "throw" === context.method) { if (delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method)) return ContinueSentinel; context.method = "throw", context.arg = new TypeError("The iterator does not provide a 'throw' method"); } return ContinueSentinel; } var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) { if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; } return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, define(Gp, "constructor", GeneratorFunctionPrototype), define(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (object) { var keys = []; for (var key in object) { keys.push(key); } return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) { "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); } }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var events_1 = require("events");

var net = require("net");

var ip = require("ip");

var smart_buffer_1 = require("smart-buffer");

var constants_1 = require("../common/constants");

var helpers_1 = require("../common/helpers");

var receivebuffer_1 = require("../common/receivebuffer");

var util_1 = require("../common/util");

var SocksClient = /*#__PURE__*/function (_events_1$EventEmitte) {
  _inherits(SocksClient, _events_1$EventEmitte);

  var _super = _createSuper(SocksClient);

  function SocksClient(options) {
    var _this;

    _classCallCheck(this, SocksClient);

    _this = _super.call(this);
    _this._options = Object.assign({}, options); // Validate SocksClientOptions

    helpers_1.validateSocksClientOptions(options); // Default state

    _this.state = constants_1.SocksClientState.Created;
    return _this;
  }
  /**
   * Creates a new SOCKS connection.
   *
   * Note: Supports callbacks and promises. Only supports the connect command.
   * @param options { SocksClientOptions } Options.
   * @param callback { Function } An optional callback function.
   * @returns { Promise }
   */


  _createClass(SocksClient, [{
    key: "state",
    get:
    /**
     * Gets the SocksClient internal state.
     */
    function get() {
      return this._state;
    }
    /**
     * Internal state setter. If the SocksClient is in an error state, it cannot be changed to a non error state.
     */
    ,
    set: function set(newState) {
      if (this._state !== constants_1.SocksClientState.Error) {
        this._state = newState;
      }
    }
    /**
     * Starts the connection establishment to the proxy and destination.
     * @param existing_socket Connected socket to use instead of creating a new one (internal use).
     */

  }, {
    key: "connect",
    value: function connect(existing_socket) {
      var _this2 = this;

      this._onDataReceived = function (data) {
        return _this2.onDataReceived(data);
      };

      this._onClose = function () {
        return _this2.onClose();
      };

      this._onError = function (err) {
        return _this2.onError(err);
      };

      this._onConnect = function () {
        return _this2.onConnect();
      }; // Start timeout timer (defaults to 30 seconds)


      var timer = setTimeout(function () {
        return _this2.onEstablishedTimeout();
      }, this._options.timeout || constants_1.DEFAULT_TIMEOUT); // check whether unref is available as it differs from browser to NodeJS (#33)

      if (timer.unref && typeof timer.unref === 'function') {
        timer.unref();
      } // If an existing socket is provided, use it to negotiate SOCKS handshake. Otherwise create a new Socket.


      if (existing_socket) {
        this._socket = existing_socket;
      } else {
        this._socket = new net.Socket();
      } // Attach Socket error handlers.


      this._socket.once('close', this._onClose);

      this._socket.once('error', this._onError);

      this._socket.once('connect', this._onConnect);

      this._socket.on('data', this._onDataReceived);

      this.state = constants_1.SocksClientState.Connecting;
      this._receiveBuffer = new receivebuffer_1.ReceiveBuffer();

      if (existing_socket) {
        this._socket.emit('connect');
      } else {
        this._socket.connect(this.getSocketOptions());

        if (this._options.set_tcp_nodelay !== undefined && this._options.set_tcp_nodelay !== null) {
          this._socket.setNoDelay(!!this._options.set_tcp_nodelay);
        }
      } // Listen for established event so we can re-emit any excess data received during handshakes.


      this.prependOnceListener('established', function (info) {
        setImmediate(function () {
          if (_this2._receiveBuffer.length > 0) {
            var excessData = _this2._receiveBuffer.get(_this2._receiveBuffer.length);

            info.socket.emit('data', excessData);
          }

          info.socket.resume();
        });
      });
    } // Socket options (defaults host/port to options.proxy.host/options.proxy.port)

  }, {
    key: "getSocketOptions",
    value: function getSocketOptions() {
      return Object.assign(Object.assign({}, this._options.socket_options), {
        host: this._options.proxy.host || this._options.proxy.ipaddress,
        port: this._options.proxy.port
      });
    }
    /**
     * Handles internal Socks timeout callback.
     * Note: If the Socks client is not BoundWaitingForConnection or Established, the connection will be closed.
     */

  }, {
    key: "onEstablishedTimeout",
    value: function onEstablishedTimeout() {
      if (this.state !== constants_1.SocksClientState.Established && this.state !== constants_1.SocksClientState.BoundWaitingForConnection) {
        this._closeSocket(constants_1.ERRORS.ProxyConnectionTimedOut);
      }
    }
    /**
     * Handles Socket connect event.
     */

  }, {
    key: "onConnect",
    value: function onConnect() {
      this.state = constants_1.SocksClientState.Connected; // Send initial handshake.

      if (this._options.proxy.type === 4) {
        this.sendSocks4InitialHandshake();
      } else {
        this.sendSocks5InitialHandshake();
      }

      this.state = constants_1.SocksClientState.SentInitialHandshake;
    }
    /**
     * Handles Socket data event.
     * @param data
     */

  }, {
    key: "onDataReceived",
    value: function onDataReceived(data) {
      /*
        All received data is appended to a ReceiveBuffer.
        This makes sure that all the data we need is received before we attempt to process it.
      */
      this._receiveBuffer.append(data); // Process data that we have.


      this.processData();
    }
    /**
     * Handles processing of the data we have received.
     */

  }, {
    key: "processData",
    value: function processData() {
      // If we have enough data to process the next step in the SOCKS handshake, proceed.
      if (this._receiveBuffer.length >= this._nextRequiredPacketBufferSize) {
        // Sent initial handshake, waiting for response.
        if (this.state === constants_1.SocksClientState.SentInitialHandshake) {
          if (this._options.proxy.type === 4) {
            // Socks v4 only has one handshake response.
            this.handleSocks4FinalHandshakeResponse();
          } else {
            // Socks v5 has two handshakes, handle initial one here.
            this.handleInitialSocks5HandshakeResponse();
          } // Sent auth request for Socks v5, waiting for response.

        } else if (this.state === constants_1.SocksClientState.SentAuthentication) {
          this.handleInitialSocks5AuthenticationHandshakeResponse(); // Sent final Socks v5 handshake, waiting for final response.
        } else if (this.state === constants_1.SocksClientState.SentFinalHandshake) {
          this.handleSocks5FinalHandshakeResponse(); // Socks BIND established. Waiting for remote connection via proxy.
        } else if (this.state === constants_1.SocksClientState.BoundWaitingForConnection) {
          if (this._options.proxy.type === 4) {
            this.handleSocks4IncomingConnectionResponse();
          } else {
            this.handleSocks5IncomingConnectionResponse();
          }
        } else if (this.state === constants_1.SocksClientState.Established) {// do nothing (prevents closing of the socket)
        } else {
          this._closeSocket(constants_1.ERRORS.InternalError);
        }
      }
    }
    /**
     * Handles Socket close event.
     * @param had_error
     */

  }, {
    key: "onClose",
    value: function onClose() {
      this._closeSocket(constants_1.ERRORS.SocketClosed);
    }
    /**
     * Handles Socket error event.
     * @param err
     */

  }, {
    key: "onError",
    value: function onError(err) {
      this._closeSocket(err.message);
    }
    /**
     * Removes internal event listeners on the underlying Socket.
     */

  }, {
    key: "removeInternalSocketHandlers",
    value: function removeInternalSocketHandlers() {
      // Pauses data flow of the socket (this is internally resumed after 'established' is emitted)
      this._socket.pause();

      this._socket.removeListener('data', this._onDataReceived);

      this._socket.removeListener('close', this._onClose);

      this._socket.removeListener('error', this._onError);

      this._socket.removeListener('connect', this.onConnect);
    }
    /**
     * Closes and destroys the underlying Socket. Emits an error event.
     * @param err { String } An error string to include in error event.
     */

  }, {
    key: "_closeSocket",
    value: function _closeSocket(err) {
      // Make sure only one 'error' event is fired for the lifetime of this SocksClient instance.
      if (this.state !== constants_1.SocksClientState.Error) {
        // Set internal state to Error.
        this.state = constants_1.SocksClientState.Error; // Destroy Socket

        this._socket.destroy(); // Remove internal listeners


        this.removeInternalSocketHandlers(); // Fire 'error' event.

        this.emit('error', new util_1.SocksClientError(err, this._options));
      }
    }
    /**
     * Sends initial Socks v4 handshake request.
     */

  }, {
    key: "sendSocks4InitialHandshake",
    value: function sendSocks4InitialHandshake() {
      var userId = this._options.proxy.userId || '';
      var buff = new smart_buffer_1.SmartBuffer();
      buff.writeUInt8(0x04);
      buff.writeUInt8(constants_1.SocksCommand[this._options.command]);
      buff.writeUInt16BE(this._options.destination.port); // Socks 4 (IPv4)

      if (net.isIPv4(this._options.destination.host)) {
        buff.writeBuffer(ip.toBuffer(this._options.destination.host));
        buff.writeStringNT(userId); // Socks 4a (hostname)
      } else {
        buff.writeUInt8(0x00);
        buff.writeUInt8(0x00);
        buff.writeUInt8(0x00);
        buff.writeUInt8(0x01);
        buff.writeStringNT(userId);
        buff.writeStringNT(this._options.destination.host);
      }

      this._nextRequiredPacketBufferSize = constants_1.SOCKS_INCOMING_PACKET_SIZES.Socks4Response;

      this._socket.write(buff.toBuffer());
    }
    /**
     * Handles Socks v4 handshake response.
     * @param data
     */

  }, {
    key: "handleSocks4FinalHandshakeResponse",
    value: function handleSocks4FinalHandshakeResponse() {
      var data = this._receiveBuffer.get(8);

      if (data[1] !== constants_1.Socks4Response.Granted) {
        this._closeSocket("".concat(constants_1.ERRORS.Socks4ProxyRejectedConnection, " - (").concat(constants_1.Socks4Response[data[1]], ")"));
      } else {
        // Bind response
        if (constants_1.SocksCommand[this._options.command] === constants_1.SocksCommand.bind) {
          var buff = smart_buffer_1.SmartBuffer.fromBuffer(data);
          buff.readOffset = 2;
          var remoteHost = {
            port: buff.readUInt16BE(),
            host: ip.fromLong(buff.readUInt32BE())
          }; // If host is 0.0.0.0, set to proxy host.

          if (remoteHost.host === '0.0.0.0') {
            remoteHost.host = this._options.proxy.ipaddress;
          }

          this.state = constants_1.SocksClientState.BoundWaitingForConnection;
          this.emit('bound', {
            socket: this._socket,
            remoteHost: remoteHost
          }); // Connect response
        } else {
          this.state = constants_1.SocksClientState.Established;
          this.removeInternalSocketHandlers();
          this.emit('established', {
            socket: this._socket
          });
        }
      }
    }
    /**
     * Handles Socks v4 incoming connection request (BIND)
     * @param data
     */

  }, {
    key: "handleSocks4IncomingConnectionResponse",
    value: function handleSocks4IncomingConnectionResponse() {
      var data = this._receiveBuffer.get(8);

      if (data[1] !== constants_1.Socks4Response.Granted) {
        this._closeSocket("".concat(constants_1.ERRORS.Socks4ProxyRejectedIncomingBoundConnection, " - (").concat(constants_1.Socks4Response[data[1]], ")"));
      } else {
        var buff = smart_buffer_1.SmartBuffer.fromBuffer(data);
        buff.readOffset = 2;
        var remoteHost = {
          port: buff.readUInt16BE(),
          host: ip.fromLong(buff.readUInt32BE())
        };
        this.state = constants_1.SocksClientState.Established;
        this.removeInternalSocketHandlers();
        this.emit('established', {
          socket: this._socket,
          remoteHost: remoteHost
        });
      }
    }
    /**
     * Sends initial Socks v5 handshake request.
     */

  }, {
    key: "sendSocks5InitialHandshake",
    value: function sendSocks5InitialHandshake() {
      var buff = new smart_buffer_1.SmartBuffer();
      buff.writeUInt8(0x05); // We should only tell the proxy we support user/pass auth if auth info is actually provided.
      // Note: As of Tor v0.3.5.7+, if user/pass auth is an option from the client, by default it will always take priority.

      if (this._options.proxy.userId || this._options.proxy.password) {
        buff.writeUInt8(2);
        buff.writeUInt8(constants_1.Socks5Auth.NoAuth);
        buff.writeUInt8(constants_1.Socks5Auth.UserPass);
      } else {
        buff.writeUInt8(1);
        buff.writeUInt8(constants_1.Socks5Auth.NoAuth);
      }

      this._nextRequiredPacketBufferSize = constants_1.SOCKS_INCOMING_PACKET_SIZES.Socks5InitialHandshakeResponse;

      this._socket.write(buff.toBuffer());

      this.state = constants_1.SocksClientState.SentInitialHandshake;
    }
    /**
     * Handles initial Socks v5 handshake response.
     * @param data
     */

  }, {
    key: "handleInitialSocks5HandshakeResponse",
    value: function handleInitialSocks5HandshakeResponse() {
      var data = this._receiveBuffer.get(2);

      if (data[0] !== 0x05) {
        this._closeSocket(constants_1.ERRORS.InvalidSocks5IntiailHandshakeSocksVersion);
      } else if (data[1] === 0xff) {
        this._closeSocket(constants_1.ERRORS.InvalidSocks5InitialHandshakeNoAcceptedAuthType);
      } else {
        // If selected Socks v5 auth method is no auth, send final handshake request.
        if (data[1] === constants_1.Socks5Auth.NoAuth) {
          this.sendSocks5CommandRequest(); // If selected Socks v5 auth method is user/password, send auth handshake.
        } else if (data[1] === constants_1.Socks5Auth.UserPass) {
          this.sendSocks5UserPassAuthentication();
        } else {
          this._closeSocket(constants_1.ERRORS.InvalidSocks5InitialHandshakeUnknownAuthType);
        }
      }
    }
    /**
     * Sends Socks v5 user & password auth handshake.
     *
     * Note: No auth and user/pass are currently supported.
     */

  }, {
    key: "sendSocks5UserPassAuthentication",
    value: function sendSocks5UserPassAuthentication() {
      var userId = this._options.proxy.userId || '';
      var password = this._options.proxy.password || '';
      var buff = new smart_buffer_1.SmartBuffer();
      buff.writeUInt8(0x01);
      buff.writeUInt8(Buffer.byteLength(userId));
      buff.writeString(userId);
      buff.writeUInt8(Buffer.byteLength(password));
      buff.writeString(password);
      this._nextRequiredPacketBufferSize = constants_1.SOCKS_INCOMING_PACKET_SIZES.Socks5UserPassAuthenticationResponse;

      this._socket.write(buff.toBuffer());

      this.state = constants_1.SocksClientState.SentAuthentication;
    }
    /**
     * Handles Socks v5 auth handshake response.
     * @param data
     */

  }, {
    key: "handleInitialSocks5AuthenticationHandshakeResponse",
    value: function handleInitialSocks5AuthenticationHandshakeResponse() {
      this.state = constants_1.SocksClientState.ReceivedAuthenticationResponse;

      var data = this._receiveBuffer.get(2);

      if (data[1] !== 0x00) {
        this._closeSocket(constants_1.ERRORS.Socks5AuthenticationFailed);
      } else {
        this.sendSocks5CommandRequest();
      }
    }
    /**
     * Sends Socks v5 final handshake request.
     */

  }, {
    key: "sendSocks5CommandRequest",
    value: function sendSocks5CommandRequest() {
      var buff = new smart_buffer_1.SmartBuffer();
      buff.writeUInt8(0x05);
      buff.writeUInt8(constants_1.SocksCommand[this._options.command]);
      buff.writeUInt8(0x00); // ipv4, ipv6, domain?

      if (net.isIPv4(this._options.destination.host)) {
        buff.writeUInt8(constants_1.Socks5HostType.IPv4);
        buff.writeBuffer(ip.toBuffer(this._options.destination.host));
      } else if (net.isIPv6(this._options.destination.host)) {
        buff.writeUInt8(constants_1.Socks5HostType.IPv6);
        buff.writeBuffer(ip.toBuffer(this._options.destination.host));
      } else {
        buff.writeUInt8(constants_1.Socks5HostType.Hostname);
        buff.writeUInt8(this._options.destination.host.length);
        buff.writeString(this._options.destination.host);
      }

      buff.writeUInt16BE(this._options.destination.port);
      this._nextRequiredPacketBufferSize = constants_1.SOCKS_INCOMING_PACKET_SIZES.Socks5ResponseHeader;

      this._socket.write(buff.toBuffer());

      this.state = constants_1.SocksClientState.SentFinalHandshake;
    }
    /**
     * Handles Socks v5 final handshake response.
     * @param data
     */

  }, {
    key: "handleSocks5FinalHandshakeResponse",
    value: function handleSocks5FinalHandshakeResponse() {
      // Peek at available data (we need at least 5 bytes to get the hostname length)
      var header = this._receiveBuffer.peek(5);

      if (header[0] !== 0x05 || header[1] !== constants_1.Socks5Response.Granted) {
        this._closeSocket("".concat(constants_1.ERRORS.InvalidSocks5FinalHandshakeRejected, " - ").concat(constants_1.Socks5Response[header[1]]));
      } else {
        // Read address type
        var addressType = header[3];
        var remoteHost;
        var buff; // IPv4

        if (addressType === constants_1.Socks5HostType.IPv4) {
          // Check if data is available.
          var dataNeeded = constants_1.SOCKS_INCOMING_PACKET_SIZES.Socks5ResponseIPv4;

          if (this._receiveBuffer.length < dataNeeded) {
            this._nextRequiredPacketBufferSize = dataNeeded;
            return;
          }

          buff = smart_buffer_1.SmartBuffer.fromBuffer(this._receiveBuffer.get(dataNeeded).slice(4));
          remoteHost = {
            host: ip.fromLong(buff.readUInt32BE()),
            port: buff.readUInt16BE()
          }; // If given host is 0.0.0.0, assume remote proxy ip instead.

          if (remoteHost.host === '0.0.0.0') {
            remoteHost.host = this._options.proxy.ipaddress;
          } // Hostname

        } else if (addressType === constants_1.Socks5HostType.Hostname) {
          var hostLength = header[4];

          var _dataNeeded = constants_1.SOCKS_INCOMING_PACKET_SIZES.Socks5ResponseHostname(hostLength); // header + host length + host + port
          // Check if data is available.


          if (this._receiveBuffer.length < _dataNeeded) {
            this._nextRequiredPacketBufferSize = _dataNeeded;
            return;
          }

          buff = smart_buffer_1.SmartBuffer.fromBuffer(this._receiveBuffer.get(_dataNeeded).slice(5) // Slice at 5 to skip host length
          );
          remoteHost = {
            host: buff.readString(hostLength),
            port: buff.readUInt16BE()
          }; // IPv6
        } else if (addressType === constants_1.Socks5HostType.IPv6) {
          // Check if data is available.
          var _dataNeeded2 = constants_1.SOCKS_INCOMING_PACKET_SIZES.Socks5ResponseIPv6;

          if (this._receiveBuffer.length < _dataNeeded2) {
            this._nextRequiredPacketBufferSize = _dataNeeded2;
            return;
          }

          buff = smart_buffer_1.SmartBuffer.fromBuffer(this._receiveBuffer.get(_dataNeeded2).slice(4));
          remoteHost = {
            host: ip.toString(buff.readBuffer(16)),
            port: buff.readUInt16BE()
          };
        } // We have everything we need


        this.state = constants_1.SocksClientState.ReceivedFinalResponse; // If using CONNECT, the client is now in the established state.

        if (constants_1.SocksCommand[this._options.command] === constants_1.SocksCommand.connect) {
          this.state = constants_1.SocksClientState.Established;
          this.removeInternalSocketHandlers();
          this.emit('established', {
            socket: this._socket
          });
        } else if (constants_1.SocksCommand[this._options.command] === constants_1.SocksCommand.bind) {
          /* If using BIND, the Socks client is now in BoundWaitingForConnection state.
             This means that the remote proxy server is waiting for a remote connection to the bound port. */
          this.state = constants_1.SocksClientState.BoundWaitingForConnection;
          this._nextRequiredPacketBufferSize = constants_1.SOCKS_INCOMING_PACKET_SIZES.Socks5ResponseHeader;
          this.emit('bound', {
            socket: this._socket,
            remoteHost: remoteHost
          });
          /*
            If using Associate, the Socks client is now Established. And the proxy server is now accepting UDP packets at the
            given bound port. This initial Socks TCP connection must remain open for the UDP relay to continue to work.
          */
        } else if (constants_1.SocksCommand[this._options.command] === constants_1.SocksCommand.associate) {
          this.state = constants_1.SocksClientState.Established;
          this.removeInternalSocketHandlers();
          this.emit('established', {
            socket: this._socket,
            remoteHost: remoteHost
          });
        }
      }
    }
    /**
     * Handles Socks v5 incoming connection request (BIND).
     */

  }, {
    key: "handleSocks5IncomingConnectionResponse",
    value: function handleSocks5IncomingConnectionResponse() {
      // Peek at available data (we need at least 5 bytes to get the hostname length)
      var header = this._receiveBuffer.peek(5);

      if (header[0] !== 0x05 || header[1] !== constants_1.Socks5Response.Granted) {
        this._closeSocket("".concat(constants_1.ERRORS.Socks5ProxyRejectedIncomingBoundConnection, " - ").concat(constants_1.Socks5Response[header[1]]));
      } else {
        // Read address type
        var addressType = header[3];
        var remoteHost;
        var buff; // IPv4

        if (addressType === constants_1.Socks5HostType.IPv4) {
          // Check if data is available.
          var dataNeeded = constants_1.SOCKS_INCOMING_PACKET_SIZES.Socks5ResponseIPv4;

          if (this._receiveBuffer.length < dataNeeded) {
            this._nextRequiredPacketBufferSize = dataNeeded;
            return;
          }

          buff = smart_buffer_1.SmartBuffer.fromBuffer(this._receiveBuffer.get(dataNeeded).slice(4));
          remoteHost = {
            host: ip.fromLong(buff.readUInt32BE()),
            port: buff.readUInt16BE()
          }; // If given host is 0.0.0.0, assume remote proxy ip instead.

          if (remoteHost.host === '0.0.0.0') {
            remoteHost.host = this._options.proxy.ipaddress;
          } // Hostname

        } else if (addressType === constants_1.Socks5HostType.Hostname) {
          var hostLength = header[4];

          var _dataNeeded3 = constants_1.SOCKS_INCOMING_PACKET_SIZES.Socks5ResponseHostname(hostLength); // header + host length + port
          // Check if data is available.


          if (this._receiveBuffer.length < _dataNeeded3) {
            this._nextRequiredPacketBufferSize = _dataNeeded3;
            return;
          }

          buff = smart_buffer_1.SmartBuffer.fromBuffer(this._receiveBuffer.get(_dataNeeded3).slice(5) // Slice at 5 to skip host length
          );
          remoteHost = {
            host: buff.readString(hostLength),
            port: buff.readUInt16BE()
          }; // IPv6
        } else if (addressType === constants_1.Socks5HostType.IPv6) {
          // Check if data is available.
          var _dataNeeded4 = constants_1.SOCKS_INCOMING_PACKET_SIZES.Socks5ResponseIPv6;

          if (this._receiveBuffer.length < _dataNeeded4) {
            this._nextRequiredPacketBufferSize = _dataNeeded4;
            return;
          }

          buff = smart_buffer_1.SmartBuffer.fromBuffer(this._receiveBuffer.get(_dataNeeded4).slice(4));
          remoteHost = {
            host: ip.toString(buff.readBuffer(16)),
            port: buff.readUInt16BE()
          };
        }

        this.state = constants_1.SocksClientState.Established;
        this.removeInternalSocketHandlers();
        this.emit('established', {
          socket: this._socket,
          remoteHost: remoteHost
        });
      }
    }
  }, {
    key: "socksClientOptions",
    get: function get() {
      return Object.assign({}, this._options);
    }
  }], [{
    key: "createConnection",
    value: function createConnection(options, callback) {
      // Validate SocksClientOptions
      helpers_1.validateSocksClientOptions(options, ['connect']);
      return new Promise(function (resolve, reject) {
        var client = new SocksClient(options);
        client.connect(options.existing_socket);
        client.once('established', function (info) {
          client.removeAllListeners();

          if (typeof callback === 'function') {
            callback(null, info);
            resolve(); // Resolves pending promise (prevents memory leaks).
          } else {
            resolve(info);
          }
        }); // Error occurred, failed to establish connection.

        client.once('error', function (err) {
          client.removeAllListeners();

          if (typeof callback === 'function') {
            callback(err);
            resolve(); // Resolves pending promise (prevents memory leaks).
          } else {
            reject(err);
          }
        });
      });
    }
    /**
     * Creates a new SOCKS connection chain to a destination host through 2 or more SOCKS proxies.
     *
     * Note: Supports callbacks and promises. Only supports the connect method.
     * Note: Implemented via createConnection() factory function.
     * @param options { SocksClientChainOptions } Options
     * @param callback { Function } An optional callback function.
     * @returns { Promise }
     */

  }, {
    key: "createConnectionChain",
    value: function createConnectionChain(options, callback) {
      var _this3 = this;

      // Validate SocksClientChainOptions
      helpers_1.validateSocksClientChainOptions(options); // Shuffle proxies

      if (options.randomizeChain) {
        util_1.shuffleArray(options.proxies);
      }

      return new Promise(function (resolve, reject) {
        return __awaiter(_this3, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
          var sock, i, nextProxy, nextDestination, result;
          return _regeneratorRuntime().wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  _context.prev = 0;
                  i = 0;

                case 2:
                  if (!(i < options.proxies.length)) {
                    _context.next = 12;
                    break;
                  }

                  nextProxy = options.proxies[i]; // If we've reached the last proxy in the chain, the destination is the actual destination, otherwise it's the next proxy.

                  nextDestination = i === options.proxies.length - 1 ? options.destination : {
                    host: options.proxies[i + 1].ipaddress,
                    port: options.proxies[i + 1].port
                  }; // Creates the next connection in the chain.

                  _context.next = 7;
                  return SocksClient.createConnection({
                    command: 'connect',
                    proxy: nextProxy,
                    destination: nextDestination // Initial connection ignores this as sock is undefined. Subsequent connections re-use the first proxy socket to form a chain.

                  });

                case 7:
                  result = _context.sent;

                  // If sock is undefined, assign it here.
                  if (!sock) {
                    sock = result.socket;
                  }

                case 9:
                  i++;
                  _context.next = 2;
                  break;

                case 12:
                  if (typeof callback === 'function') {
                    callback(null, {
                      socket: sock
                    });
                    resolve(); // Resolves pending promise (prevents memory leaks).
                  } else {
                    resolve({
                      socket: sock
                    });
                  }

                  _context.next = 18;
                  break;

                case 15:
                  _context.prev = 15;
                  _context.t0 = _context["catch"](0);

                  if (typeof callback === 'function') {
                    callback(_context.t0);
                    resolve(); // Resolves pending promise (prevents memory leaks).
                  } else {
                    reject(_context.t0);
                  }

                case 18:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee, null, [[0, 15]]);
        }));
      });
    }
    /**
     * Creates a SOCKS UDP Frame.
     * @param options
     */

  }, {
    key: "createUDPFrame",
    value: function createUDPFrame(options) {
      var buff = new smart_buffer_1.SmartBuffer();
      buff.writeUInt16BE(0);
      buff.writeUInt8(options.frameNumber || 0); // IPv4/IPv6/Hostname

      if (net.isIPv4(options.remoteHost.host)) {
        buff.writeUInt8(constants_1.Socks5HostType.IPv4);
        buff.writeUInt32BE(ip.toLong(options.remoteHost.host));
      } else if (net.isIPv6(options.remoteHost.host)) {
        buff.writeUInt8(constants_1.Socks5HostType.IPv6);
        buff.writeBuffer(ip.toBuffer(options.remoteHost.host));
      } else {
        buff.writeUInt8(constants_1.Socks5HostType.Hostname);
        buff.writeUInt8(Buffer.byteLength(options.remoteHost.host));
        buff.writeString(options.remoteHost.host);
      } // Port


      buff.writeUInt16BE(options.remoteHost.port); // Data

      buff.writeBuffer(options.data);
      return buff.toBuffer();
    }
    /**
     * Parses a SOCKS UDP frame.
     * @param data
     */

  }, {
    key: "parseUDPFrame",
    value: function parseUDPFrame(data) {
      var buff = smart_buffer_1.SmartBuffer.fromBuffer(data);
      buff.readOffset = 2;
      var frameNumber = buff.readUInt8();
      var hostType = buff.readUInt8();
      var remoteHost;

      if (hostType === constants_1.Socks5HostType.IPv4) {
        remoteHost = ip.fromLong(buff.readUInt32BE());
      } else if (hostType === constants_1.Socks5HostType.IPv6) {
        remoteHost = ip.toString(buff.readBuffer(16));
      } else {
        remoteHost = buff.readString(buff.readUInt8());
      }

      var remotePort = buff.readUInt16BE();
      return {
        frameNumber: frameNumber,
        remoteHost: {
          host: remoteHost,
          port: remotePort
        },
        data: buff.readBuffer()
      };
    }
  }]);

  return SocksClient;
}(events_1.EventEmitter);

exports.SocksClient = SocksClient;